import React, { FC } from 'react';
import '../style.scss';
import { EstablishError } from 'views/components/atoms/establishes/error';
import { EstablishHeader } from 'views/components/atoms/establishes/header';
import { EstablishText, MaskAttr } from 'views/components/atoms/establishes/text';
import { EstablishCheck, EstablishCheckProps } from 'views/components/atoms/establishes/check';

type InputLetterProps = {
  title: string;
  inputType: string;
  inputValue?: string;
  setInputValue?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isEnable: boolean;
  errorText?: string;
  placeholder?: string;
  batchDangerWord?: string;
  checkButtonProps?: EstablishCheckProps;
  masked?: MaskAttr;
};

export const InputLetter: FC<InputLetterProps> = (props) => {
  const {
    title,
    inputType,
    inputValue,
    setInputValue,
    isEnable,
    errorText,
    placeholder,
    batchDangerWord,
    checkButtonProps,
    masked,
  } = props;
  return (
    <div className="inputWrapper">
      <EstablishHeader headerTitle={title} batchDangerWord={batchDangerWord} />
      <div className="flexWrapper">
        <EstablishText
          inputType={inputType}
          inputValue={inputValue}
          setInputValue={setInputValue}
          placeholder={placeholder}
          disabled={checkButtonProps?.isChecked}
          masked={masked}
        />
        {checkButtonProps && <EstablishCheck {...checkButtonProps} />}
      </div>
      <EstablishError isEnabled={isEnable} errorText={errorText} />
    </div>
  );
};
